import { Polling } from "./polling.js";
import { WS } from "./websocket.js";
import { WT } from "./webtransport.js";
export const transports = {
    websocket: WS,
    webtransport: WT,
    polling: Polling,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/build/esm/transports/index.js
// module id = null
// module chunks = 